import { atom } from "recoil";

export const currentUserIsAdminAtom = atom({
  key: "currentUserIsAdminAtom", // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});

export const currentUserIsAuthAtom = atom({
  key: "currentUserIsAuthAtom", // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});
